import angular from "angular";
import { Translations } from "@salaxy/core";
/**
 * Controller for the tab buttons control.
 */
export class TabButtonsController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["$location", "$timeout", "$scope"];

  /**
   * Tab Options:
   * - `value`: Unique identifier for the tab.
   * - `label`: The text displayed for the tab in the UI.
   * - `isDefault`: If `true`, this tab will be selected by default.
   * - `hidden`: If `true`, the tab will be hidden based on certain conditions or parameters.
   */
  public options: { value: string, label: string, isDefault?: boolean, hidden?: boolean }[];
  /* Currently active tab */
  public currentTab: string;
  /* Tracks the tabs' id (the context). Makes it possible to tabs have tabs (and have tabs etc...) inside them. */
  public tabsId: string;
  /* Customizable default tab (can be passed from a parent that uses a template with tabs). */
  public defaultTab: string = "";
  /* Whether the tab parameter in the url should update on tab change. Note; causes browser reload, so not advicable to use unless a must-have. Angular JS's default routing option causes this, and (for now) can't be changed. */
  public updateTabParam: boolean = false;
  /* Configured default tab to show on page load. */
  public elemDefaultTab: string;

  /**
   * Creates a new TabButtonsController.
   * @ignore
   */
  constructor(private $location: angular.ILocationService, private $timeout: angular.ITimeoutService, private $scope: angular.IScope) {
  }

  /** Sets default tab value on component initialization. If default tab is not manually set, defaults to the first tab in the options list. */
  public $onInit() {
    this.elemDefaultTab = this.defaultTab || this.options.find((option) => option.isDefault)?.value || this.options[0].value;
    let chosenTab = this.elemDefaultTab;

    const paramTab = this.$location.search().tab;
    const tabs = this.options.map((option: any) => option.value);
    if (paramTab && tabs.includes(paramTab)) {
      chosenTab = paramTab;
    }
    this.currentTab = chosenTab;

    this.showTab(this.currentTab);

    this.$timeout(() => {
      this.$scope.$emit("tabButtonsControllerReady", { ctrl: this, tabsId: this.tabsId });
    }, 0);
  }

  /**
   * Shows a tab programmatically.
   * @param tabValue Tab's id text value.
   */
  public showTab(tabValue: string) {
    this.clearSelection();
    this.currentTab = tabValue;

    const tabContentElement = document.getElementById(`tab-content-${this.tabsId}`);
    if (tabContentElement) {
      const tabPaneElement = tabContentElement.querySelector(`#${tabValue}-tab`);
      if (tabPaneElement) {
        tabPaneElement.classList.add("active");
        tabPaneElement.classList.add("show");

        if (this.updateTabParam) {
          this.updateUrlTab(tabValue);
        }
      }
    }
  }

  /**
   * Updates url value of selected tab.
   * @param tabValue Selected tab.
   */
  private updateUrlTab(tabValue) {
    // Either page load or switched to default tab. Value "null" removes the tab param altogether.
    if (this.elemDefaultTab == tabValue) {
      tabValue = null;
    }
    this.$location.search("tab", tabValue);
  }


  /**
   * Clears previously selected tabs (removes classes).
   */
  private clearSelection() {
    const allTabPanes = document.querySelectorAll(`#tab-content-${this.tabsId} > .tab-pane`);
    allTabPanes.forEach(pane => {
      pane.classList.remove("active");
      pane.classList.remove("show");
    });
  }

  /**
   * Return the text value for tab button, either a translation or numerical value.
   * @param tabText Tab text value to be returned.
   * @returns Tab button text.
   */
  public getTabText(tabText) {
    if (typeof tabText === "number") {
      return tabText;
    } else {
      return Translations.get(tabText);
    }
  }
}